module.exports = __webpack_public_path__ + "img/wx_jiazhao_bc@2x.79c5d74f.png";